import {
  Button,
  InputNumber,
  Select,
  Space,
  message,
  Popconfirm,
  Table,
  Typography,
} from "antd";
import { CloseOutlined, PlusOutlined } from "@ant-design/icons";
import React, { useState } from "react";
import { Auth, Utils } from "_helpers";

const TableForm = ({ value, onChange, materialTypes, measurementTypes }) => {
  const [index, setIndex] = useState(0);
  const [data, setData] = useState(value);
  const { Option } = Select;
  const { Text } = Typography;

  const getRowByKey = (key, newData) =>
    (newData || data)?.filter((item) => item.key === key)[0];

  const handleAddMaterialLine = () => {
    const newData = data?.map((item) => ({ ...item })) || [];

    const defaultMeasurementType = measurementTypes.find(
      (item) => item.name === "KG"
    );
    const newLine =
      defaultMeasurementType === null
        ? { key: `NEW_TEMP_ID_${index}`, quantity: null }
        : {
            key: `NEW_TEMP_ID_${index}`,
            quantityPerUnit: null,
            uom: defaultMeasurementType,
          };
    newData.push(newLine);

    setIndex(index + 1);
    setData(newData);
    if (onChange) {
      onChange(newData);
    }
  };

  const handleRemoveMaterialLine = (key) => {
    const newData = data?.filter((item) => item.key !== key);
    setData(newData);
    if (onChange) {
      onChange(newData);
    }
  };

  const handleSaveMaterialLine = (e, key) => {
    e.persist();
    const target = getRowByKey(key) || {};
    if (
      !target.materialType ||
      !target.quantityPerUnit ||
      !target.conversionRatio ||
      !target.wastagePercentage ||
      !target.uom
    ) {
      message.error("Please complete the material line information.");
      e.target.focus();
      return;
    } else {
      handleAddMaterialLine();
    }
  };

  const handleFieldChange = (value, fieldName, key) => {
    const newData = [...data];
    const target = getRowByKey(key, newData);
    if (target) {
      if (["materialType", "uom"].includes(fieldName)) {
        target[fieldName] = { id: value };
      } else {
        target[fieldName] = value;
      }

      setData(newData);
    }
  };

  const columns = [
    {
      title: "Material Type",
      dataIndex: "materialType",
      key: "materialType",
      width: "20%",
      defaultSortOrder: "descend",
      sorter: (a, b) =>
        a.materialType &&
        a.materialType.code &&
        b.materialType &&
        b.materialType.code &&
        a.materialType.code.localeCompare(b.materialType.code),
      render: (text, record) => {
        return (
          <Select
            value={record.materialType && record.materialType.id}
            placeholder="Please select"
            allowClear
            showSearch
            optionFilterProp="children"
            onChange={(e) => handleFieldChange(e, "materialType", record.key)}
          >
            {materialTypes.length > 0 &&
              materialTypes.map((t) => (
                <Option value={t.id} key={t.id}>
                  {t.code} ({t.name})
                </Option>
              ))}
          </Select>
        );
      },
    },
    {
      title: "Quantity Per Unit",
      dataIndex: "quantityPerUnit",
      key: "quantityPerUnit",
      render: (text, record) => {
        return (
          <InputNumber
            value={text}
            onChange={(e) =>
              handleFieldChange(e, "quantityPerUnit", record.key)
            }
            min={0}
            placeholder="Quantity Per Unit"
          />
        );
      },
    },
    {
      title: "Conversion Ratio",
      dataIndex: "conversionRatio",
      key: "conversionRatio",
      render: (text, record) => {
        return (
          <InputNumber
            value={text}
            onChange={(e) =>
              handleFieldChange(e, "conversionRatio", record.key)
            }
            min={0}
            placeholder="Conversion Ratio"
          />
        );
      },
    },
    {
      title: "Wastage Percentage",
      dataIndex: "wastagePercentage",
      key: "wastagePercentage",
      render: (text, record) => {
        return (
          <InputNumber
            value={text}
            onChange={(e) =>
              handleFieldChange(e, "wastagePercentage", record.key)
            }
            min={0}
            placeholder="Wastage Percentage"
          />
        );
      },
    },
    {
      title: "UOM",
      dataIndex: "uom",
      key: "uom",
      width: "10%",
      render: (text, record) => {
        return (
          <Select
            value={record.uom && record.uom.id}
            placeholder="Please select"
            allowClear
            showSearch
            optionFilterProp="children"
            onChange={(e) => handleFieldChange(e, "uom", record.key)}
          >
            {measurementTypes.length > 0 &&
              measurementTypes.map((t) => (
                <Option value={t.id} key={t.id}>
                  {t.name}
                </Option>
              ))}
          </Select>
        );
      },
    },
    {
      title: "",
      key: "operation",
      render: (text, record) => {
        return (
          <Space size="small">
            <Popconfirm
              title="Are you sure to remove?"
              onConfirm={() => handleRemoveMaterialLine(record.key)}
              key="remove-confirm"
            >
              <Button
                size="small"
                icon={<CloseOutlined />}
                //onClick={() => handleRemoveOrderLine(record.key)}
              ></Button>
            </Popconfirm>
            <Button
              type="primary"
              onClick={(e) => {
                e.preventDefault();
                handleSaveMaterialLine(e, record.key);
              }}
              style={{ padding: 5, fontSize: 12 }}
            >
              +More
            </Button>
          </Space>
        );
      },
    },
  ];

  return (
    <>
      {data && data.length === 0 && (
        <Button
          style={{
            width: "100%",
            marginTop: 16,
            marginBottom: 8,
            background: "rgb(190, 200, 200)",
          }}
          type="dashed"
          onClick={handleAddMaterialLine}
          icon={<PlusOutlined />}
        >
          Add Item
        </Button>
      )}
      <Table
        bordered
        columns={columns}
        dataSource={data}
        pagination={false}
        size="small"
      />
    </>
  );
};

export default TableForm;
